import { IDs } from './IDs';

export class RoutingIDs {

    // public static MENUE_ENERGIE_COCKPIT = 0;
    public static MENUE_DATENEINGABE = 0;
    public static MENUE_DATENAUSWERTUNG = 1;
    public static MENUE_EFFIZIENZNETZWERK = 2; // disabled
    public static MENUE_ZUSATZTOOLS = 2;
    public static MENUE_INFORMATIONEN_HILFE = 3;

    public static TABS_DATEIABLAGE = 'tabDateiablage';
    // public static TABS_DATEIABLAGE_GEBAEUDE = 'tabDateiablageGebaeude';
    // public static TABS_DATEIABLAGE_VERTRAEGE = 'tabDateiablageVertraege';
    public static TABS_DATENAUSWERTUNG = 'tabDatenauswertung';
    public static TABS_DATENAUSWERTUNG_CO2_FUSS = 'tabDatenauswertungCO2';
    public static TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN = 'tabDatenauswertungEnergiekennzahlen';
    public static TABS_DATENAUSWERTUNG_STANDORTE = 'tabDatenauswertungStandortTabs';
    public static TABS_DATENAUSWERTUNG_VSME = 'tabDatenauswertungVsme';
    public static TABS_DATENAUSWERTUNG_WAERME = 'tabDatenauswertungWaerme';
    public static TABS_DATENEINGABE = 'tabDateneingabe';
    public static TABS_DATENEINGABE_BETRIEBLICHE_DATEN = 'tabDateneingabeBetrieblicheDaten';
    public static TABS_DATENEINGABE_CO2_KOMPLEX = 'tabDateneingabeCO2Komplex';
    public static TABS_DATENEINGABE_ENERGIEDATEN = 'tabDateneingabeEnergiedaten';
    public static TABS_DATENEINGABE_ENERGIEDATEN_KOMPLEX = 'tabDateneingabeEnergiedatenKomplex';
    public static TABS_DATENEINGABE_ERNEUERBARE_ENERGIEN = 'tabDateneingabeErneuerbareEnergien';
    public static TABS_DATENEINGABE_FAHRZEUGE = 'tabDateneingabeFahrzeuge';
    public static TABS_DATENEINGABE_MASCHINEN = 'tabDateneingabeMaschinen';
    // public static TABS_EFFIZIENZNETZWERK = 'tabEffizienznetzwerk';
    // public static TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE = 'tabEffizienznetzwerkDokumentenablage';
    // public static TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE = 'tabEffizienznetzwerkDokumentenablageGebaeude';
    // public static TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_VERTRAEGE = 'tabEffizienznetzwerkDokumentenablageVertraege';
    public static TABS_INFORMATIONEN_HILFE = 'tabInformationenHilfe';
    public static TABS_INFORMATIONEN_HILFE_PARTNER = 'tabInformationenHilfePartner';
    public static TABS_STANDORTE_DETAIL = 'tabStandorteDetail';
    public static TABS_STANDORTE_ERNEUERBARE_ENERGIEN = 'tabStandorteEigenstromTabs';
    public static TABS_ZUSATZTOOLS = 'tabZusatztools';
    public static TABS_ZUSATZTOOLS_DOKUMENTENABLAGE = 'tabZusatztoolsDokumentenablage';
    public static TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_GEBAEUDE = 'tabZusatztoolsDokumentenablageGebaeude';
    public static TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_VERTRAEGE = 'tabZusatztoolsDokumentenablageVertraege';
    public static TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK = 'tabEffizienznetzwerk';
    public static TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE = 'tabEffizienznetzwerkDokumentenablage';
    public static TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE = 'tabEffizienznetzwerkDokumentenablageGebaeude';
    public static TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_VERTRAEGE = 'tabEffizienznetzwerkDokumentenablageVertraege';
    public static TABS_ZUSATZTOOLS_PV = 'tabZusatztoolsPv';
    public static TABS_ZUSATZTOOLS_ZERTIFIZIERUNG = 'tabZusatztoolsZertifizierung';
    public static TABS_ZUSATZTOOLS_ZERTIFIZIERUNG_TABELLEN = 'tabZusatztoolsZertifizierungTabellen';

    public static TABS_STANDORTE_GRUPPE_ITEM = 'tabStandorteGruppeItem';

    public static TAB_ABLAGE_SAMMELREGISTER = 0;
    public static TAB_BETRIEBLICHE_DATEN_MOTIVATION = 0;
    public static TAB_BETRIEBLICHE_DATEN_KONFIGURATION = 1;
    public static TAB_BETRIEBLICHE_DATEN_UNTERNEHMENSDATEN = 2;
    public static TAB_BETRIEBLICHE_DATEN_STANDORTE_GEBAEUDE = 3;
    public static TAB_BETRIEBLICHE_DATEN_ZUSTAENDIGKEITEN = 4;
    public static TAB_BETRIEBLICHE_DATEN_BWL_DATEN = 5;
    public static TAB_BETRIEBLICHE_DATEN_KENNZAHLEN = 6;
    public static TAB_BETRIEBLICHE_DATEN_SONSTIGE_DATEN = 7;
    public static TAB_BETRIEBLICHE_DATEN_VERANSTALTUNGEN = 8;
    public static TAB_CO2_FUSS_GESAMT = 0;
    public static TAB_CO2_FUSS_DETAILS = 1;
    public static TAB_CO2_FUSS_ANTEIL_STANDORTE = 2;
    public static TAB_CO2_FUSS_THG_BERICHT = 3;
    public static TAB_DATENAUSWERTUNG_ENERGIE_COCKPIT = 0;
    public static TAB_DATENAUSWERTUNG_STANDORTE_GESAMT = 1;
    public static TAB_DATENAUSWERTUNG_STROM = 0;
    public static TAB_DATENAUSWERTUNG_WAERME = 1;
    public static TAB_DATENAUSWERTUNG_KRAFTSTOFFE = 2;
    public static TAB_DATENAUSWERTUNG_WASSER = 3;
    public static TAB_DATENAUSWERTUNG_ENERGIEKENNZAHLEN = 4;
    public static TAB_DATENAUSWERTUNG_ENERGIESTEUER = 5;
    public static TAB_DATENAUSWERTUNG_BETRIEBSDATEN = 6;
    public static TAB_DATENAUSWERTUNG_MASCHINEN_ANLAGEN_HEIZUNG = 7;
    public static TAB_DATENAUSWERTUNG_FAHRZEUGE = 8;
    public static TAB_DATENAUSWERTUNG_ERNEUERBARE_ENERGIEN = 9;
    public static TAB_DATENAUSWERTUNG_CO2 = 10;
    public static TAB_DATENAUSWERTUNG_VSME = 11;
    public static TAB_DATENAUSWERTUNG_KENNZAHLENBERECHNUNG = 12;
    public static TAB_DATENEINGABE_BETRIEBLICHE_DATEN = 0;
    public static TAB_DATENEINGABE_ENERGIEDATEN_KOMPLEX = 1;
    public static TAB_DATENEINGABE_CO2_KOMPLEX = 2;
    public static TAB_DATENEINGABE_MASCHINEN_ANLAGEN = 3;
    public static TAB_DATENEINGABE_FAHRZEUGE = 4;
    public static TAB_DATENEINGABE_ERNEUERBARE_ENERGIEN = 5;
    public static TAB_DATENEINGABE_EINGABEKONTROLLE = 6;
    public static TAB_DATENEINGABE_ENERGIEDATEN = 7;
    public static TAB_DATENEINGABE_DATENCHECK = 8;
    public static TAB_DATENEINGABE_AN_ABREISE = 9;
    public static TAB_EFFIZIENZNETZWERK_DOKUMENTENABLAGE = 0;
    public static TAB_EFFIZIENZNETZWERK_MONITORING_EINZELMASSNAHMEN = 1;
    public static TAB_ENERGIEDATEN_STROM = 0;
    public static TAB_ENERGIEDATEN_WAERME = 1;
    public static TAB_ENERGIEDATEN_KRAFTSTOFFE = 2;
    public static TAB_ENERGIEDATEN_WASSER = 3;
    public static TAB_ENERGIEDATEN_EIGENSTROM = 4;
    public static TAB_ENERGIEDATEN_EIGENWAERME = 5;
    public static TAB_ENERGIEDATEN_KENNZIFFERN = 6;
    public static TAB_ENERGIEDATEN_BWL_DATEN = 7;
    public static TAB_ENERGIEDATEN_KLIMAGASE = 8;
    public static TAB_ENERGIEDATEN_SICHERHEITSZUSCHLAG = 9;
    public static TAB_ENERGIEDATEN_SCOPE3_TRANSPORT_VORGELAGERT = 10;
    public static TAB_ENERGIEDATEN_SCOPE3_GESCHAEFTSREISEN = 11;
    public static TAB_ENERGIEKENNZAHLEN_KOSTENBEZOGEN = 0;
    public static TAB_ENERGIEKENNZAHLEN_VERBRAUCHSBEZOGEN = 1;
    public static TAB_ENERGIEKENNZAHLEN_KOSTENBEZOGEN_SPEZ = 2;
    public static TAB_ENERGIEKENNZAHLEN_VERBRAUCHSBEZOGEN_SPEZ = 3;
    public static TAB_ENERGIEKENNZAHLEN_CO2_EMISSIONEN = 4;
    public static TAB_ENERGIEKENNZAHLEN_BROWSER = 5;
    public static TAB_ERNEUERBARE_ENERGIEN_AUSWAHL = 0;
    public static TAB_ERNEUERBARE_ENERGIEN_KWK = 1;
    public static TAB_ERNEUERBARE_ENERGIEN_PHOTOVOLTAIK = 2;
    public static TAB_ERNEUERBARE_ENERGIEN_WINDKRAFT = 3;
    public static TAB_ERNEUERBARE_ENERGIEN_BIOMASSE = 4;
    public static TAB_ERNEUERBARE_ENERGIEN_SOLARTHERMIE = 5;
    public static TAB_ERNEUERBARE_ENERGIEN_WAERMEPUMPEN = 6;
    public static TAB_INFORMATIONEN_HILFE_ERLAEUTERUNGEN = 0;
    public static TAB_INFORMATIONEN_HILFE_SITEMAP = 1;
    public static TAB_INFORMATIONEN_HILFE_FAQ = 2;
    public static TAB_INFORMATIONEN_HILFE_GLOSSAR = 3;
    public static TAB_INFORMATIONEN_HILFE_FOERDERUNG = 4;
    public static TAB_INFORMATIONEN_HILFE_MEDIEN = 5;
    public static TAB_INFORMATIONEN_HILFE_EMISSIONSFAKTOREN_HEIZWERTE = 6;
    public static TAB_INFORMATIONEN_HILFE_VERSIONSHISTORIE = 7;
    public static TAB_INFORMATIONEN_HILFE_VERIFIZIERUNG = 8;
    public static TAB_INFORMATIONEN_HILFE_KONTAKTE = 9;
    public static TAB_INFORMATIONEN_HILFE_PARTNER = 10;
    public static TAB_INFORMATIONEN_HILFE_NUTZUNGSBEDINGUNGEN = 11;
    public static TAB_INFORMATIONEN_HILFE_IMPRESSUM = 12;
    public static TAB_PARTNER_FINANZIERUNG = 0;
    public static TAB_PARTNER_ENTWICKLUNG = 1;
    public static TAB_PARTNER_WEITERFUEHREND = 2;
    public static TAB_PV_STANDARD = 0;
    public static TAB_PV_EXPERTE = 1;
    public static TAB_STANDORT_DETAIL = 0;
    public static TAB_STANDORT_GEBAEUDE = 1;
    public static TAB_STANDORT_MASCHINEN_ANLAGEN = 2;
    public static TAB_STANDORT_FAHRZEUGE = 3;
    public static TAB_STANDORT_ENERGIETRAEGER = 4;
    public static TAB_STANDORT_ERNEUERBARE_ENERGIEN = 5;
    public static TAB_STARTSEITE_WILLKOMMEN = 0;
    public static TAB_STARTSEITE_ENERGIE_COCKPIT = 1;
    public static TAB_STARTSEITE_DASHBOARD = 2;
    public static TAB_ZERTIFIZIERUNG_OPTIONEN = 0;
    public static TAB_ZERTIFIZIERUNG_INFO = 1;
    public static TAB_ZERTIFIZIERUNG_TABELLEN = 2;
    public static TAB_ZERTIFIZIERUNG_TABELLE1 = 0;
    public static TAB_ZERTIFIZIERUNG_TABELLE2 = 1;
    public static TAB_ZERTIFIZIERUNG_TABELLE3 = 2;
    public static TAB_ZERTIFIZIERUNG_TESTIERUNG = 3;
    public static TAB_ZUSATZTOOLS_KOSTEN_PROJEKTION = 0;
    public static TAB_ZUSATZTOOLS_DOKUMENTENABLAGE = 1;
    public static TAB_ZUSATZTOOLS_EFFIZIENZNETZWERK = 2;
    public static TAB_ZUSATZTOOLS_ECOMAPPING = 3;
    public static TAB_ZUSATZTOOLS_ENTWICKLUNGSPLAN = 4;
    public static TAB_ZUSATZTOOLS_TOOL_EXCEL_IMPORT = 5;
    public static TAB_ZUSATZTOOLS_LASTGAENGE = 6;
    public static TAB_ZUSATZTOOLS_CO2_TOOL = 7;
    public static TAB_ZUSATZTOOLS_MONITORING_EINZELMASSNAHMEN = 8;
    public static TAB_ZUSATZTOOLS_PV = 9;
    public static TAB_ZUSATZTOOLS_ZAEHLER = 10;
    public static TAB_ZUSATZTOOLS_ZERTIFIZIERUNG = 11;
    public static TAB_ZUSATZTOOLS_INFOS_BERATER = 12;
    public static TAB_ZUSATZTOOLS_REPORT_EXPORT = 13;
    public static TAB_ZUSATZTOOLS_EED = 14;
    public static TAB_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE = 0;
    public static TAB_ZUSATZTOOLS_EFFIZIENZNETZWERK_MONITORING_EINZELMASSNAHMEN = 1;
    public static TAB_VSME_AUSWERTUNG = 0;
    public static TAB_VSME_REPORT = 1;

    // AB HIER DIE ROUTEN

    // ... ZUERST DIE BASIS-ROUTEN DIE WIR HÄUFIGER BRAUCHEN
    public static ROUTE_STANDORT = {
        selectedMenu: RoutingIDs.MENUE_DATENEINGABE,
        tabDateneingabe: RoutingIDs.TAB_DATENEINGABE_BETRIEBLICHE_DATEN,
        tabDateneingabeBetrieblicheDaten: RoutingIDs.TAB_BETRIEBLICHE_DATEN_STANDORTE_GEBAEUDE,
        terminateOn: RoutingIDs.TABS_STANDORTE_DETAIL // Wenn wir weiter routen wollen, muss das überschrieben
        // werden falls nicht ist es schon da
    };
    public static ROUTE_ERNEUERBARE_ENERGIEN = {
        ...RoutingIDs.ROUTE_STANDORT,
        [RoutingIDs.TABS_STANDORTE_DETAIL]: RoutingIDs.TAB_STANDORT_ERNEUERBARE_ENERGIEN,
        terminateOn: 'tabStandorteEigenstromTabs'
    };
    public static ROUTE_ENERGIEDATEN = {
        selectedMenu: RoutingIDs.MENUE_DATENEINGABE,
        tabDateneingabe: RoutingIDs.TAB_DATENEINGABE_ENERGIEDATEN,
        terminateOn: 'tabDateneingabeEnergiedaten'
    };
    // SITEMAP
    // Level 0
    public static ROUTE_DATENEINGABE = {
        selectedMenu: RoutingIDs.MENUE_DATENEINGABE
    };
    public static ROUTE_DATENAUSWERTUNG = {
        selectedMenu: RoutingIDs.MENUE_DATENAUSWERTUNG
    };
    public static ROUTE_EFFIZIENZNETZWERK = {
        selectedMenu: RoutingIDs.MENUE_EFFIZIENZNETZWERK
    };
    public static ROUTE_ZUSATZTOOLS = {
        selectedMenu: RoutingIDs.MENUE_ZUSATZTOOLS
    };
    public static ROUTE_INFORMATIONEN_HILFE = {
        selectedMenu: RoutingIDs.MENUE_INFORMATIONEN_HILFE
    };
    // Level 1
    public static ROUTE_DATENEINGABE_BETRIEBLICHE_DATEN = {
        ...RoutingIDs.ROUTE_DATENEINGABE,
        [RoutingIDs.TABS_DATENEINGABE]: RoutingIDs.TAB_DATENEINGABE_BETRIEBLICHE_DATEN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE
    };
    public static ROUTE_DATENEINGABE_ENERGIEDATEN_KOMPLEX = {
        ...RoutingIDs.ROUTE_DATENEINGABE,
        [RoutingIDs.TABS_DATENEINGABE]: RoutingIDs.TAB_DATENEINGABE_ENERGIEDATEN_KOMPLEX,
        terminateOn: RoutingIDs.TABS_DATENEINGABE
    };
    public static ROUTE_DATENEINGABE_CO2_KOMPLEX = {
        ...RoutingIDs.ROUTE_DATENEINGABE,
        [RoutingIDs.TABS_DATENEINGABE]: RoutingIDs.TAB_DATENEINGABE_CO2_KOMPLEX,
        terminateOn: RoutingIDs.TABS_DATENEINGABE
    };
    public static ROUTE_DATENEINGABE_MASCHINEN_ANLAGEN = {
        ...RoutingIDs.ROUTE_DATENEINGABE,
        [RoutingIDs.TABS_DATENEINGABE]: RoutingIDs.TAB_DATENEINGABE_MASCHINEN_ANLAGEN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE
    };
    public static ROUTE_DATENEINGABE_FAHRZEUGE = {
        ...RoutingIDs.ROUTE_DATENEINGABE,
        [RoutingIDs.TABS_DATENEINGABE]: RoutingIDs.TAB_DATENEINGABE_FAHRZEUGE,
        terminateOn: RoutingIDs.TABS_DATENEINGABE
    };
    public static ROUTE_DATENEINGABE_ERNEUERBARE_ENERGIEN = {
        ...RoutingIDs.ROUTE_DATENEINGABE,
        [RoutingIDs.TABS_DATENEINGABE]: RoutingIDs.TAB_DATENEINGABE_ERNEUERBARE_ENERGIEN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE
    };
    public static ROUTE_DATENEINGABE_EINGABEKONTROLLE = {
        ...RoutingIDs.ROUTE_DATENEINGABE,
        [RoutingIDs.TABS_DATENEINGABE]: RoutingIDs.TAB_DATENEINGABE_EINGABEKONTROLLE,
        terminateOn: RoutingIDs.TABS_DATENEINGABE
    };
    public static ROUTE_DATENEINGABE_ENERGIEDATEN = {
        ...RoutingIDs.ROUTE_DATENEINGABE,
        [RoutingIDs.TABS_DATENEINGABE]: RoutingIDs.TAB_DATENEINGABE_ENERGIEDATEN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE
    };
    public static ROUTE_DATENEINGABE_DATENCHECK = {
        ...RoutingIDs.ROUTE_DATENEINGABE,
        [RoutingIDs.TABS_DATENEINGABE]: RoutingIDs.TAB_DATENEINGABE_DATENCHECK,
        terminateOn: RoutingIDs.TABS_DATENEINGABE
    };
    public static ROUTE_DATENEINGABE_AN_ABREISE = {
        ...RoutingIDs.ROUTE_DATENEINGABE,
        [RoutingIDs.TABS_DATENEINGABE]: RoutingIDs.TAB_DATENEINGABE_AN_ABREISE,
        terminateOn: RoutingIDs.TABS_DATENEINGABE
    };
    public static ROUTE_ENERGIE_COCKPIT = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG,
        [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: RoutingIDs.TAB_DATENAUSWERTUNG_ENERGIE_COCKPIT,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE
    };
    public static ROUTE_DATENAUSWERTUNG_STANDORTE = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG,
        [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: RoutingIDs.TAB_DATENAUSWERTUNG_STANDORTE_GESAMT,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE
    };
    // public static ROUTE_EFFIZIENZNETZWERK_DOKUMENTENABLAGE = {
    //     ...RoutingIDs.ROUTE_EFFIZIENZNETZWERK,
    //     [RoutingIDs.TABS_EFFIZIENZNETZWERK]: RoutingIDs.TAB_EFFIZIENZNETZWERK_DOKUMENTENABLAGE,
    //     terminateOn: RoutingIDs.TABS_EFFIZIENZNETZWERK
    // };
    // public static ROUTE_EFFIZIENZNETZWERK_MONITORING_EINZELMASSNAHMEN = {
    //     ...RoutingIDs.ROUTE_EFFIZIENZNETZWERK,
    //     [RoutingIDs.TABS_EFFIZIENZNETZWERK]: RoutingIDs.TAB_EFFIZIENZNETZWERK_MONITORING_EINZELMASSNAHMEN,
    //     terminateOn: RoutingIDs.TABS_EFFIZIENZNETZWERK
    // };
    public static ROUTE_ZUSATZTOOLS_KOSTEN_PROJEKTION = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_KOSTEN_PROJEKTION,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_DOKUMENTENABLAGE = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_DOKUMENTENABLAGE,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_ECOMAPPING = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_ECOMAPPING,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_ENTWICKLUNGSPLAN = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_ENTWICKLUNGSPLAN,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_TOOL_EXCEL_IMPORT = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_TOOL_EXCEL_IMPORT,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_LASTGAENGE = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_LASTGAENGE,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_CO2_TOOL = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_CO2_TOOL,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_MONITORING_EINZELMASSNAHMEN = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_MONITORING_EINZELMASSNAHMEN,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_PV = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_PV,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_ZAEHLER = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_ZAEHLER,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_ZERTIFIZIERUNG = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_ZERTIFIZIERUNG,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_INFOS_BERATER = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_INFOS_BERATER,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_REPORT_EXPORT = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_REPORT_EXPORT,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_EED = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_EED,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_ZUSATZTOOLS_EFFIZIENZNETZWERK = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS,
        [RoutingIDs.TABS_ZUSATZTOOLS]: RoutingIDs.TAB_ZUSATZTOOLS_EFFIZIENZNETZWERK,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS
    };
    public static ROUTE_INFORMATIONEN_HILFE_ERLAEUTERUNGEN = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_ERLAEUTERUNGEN,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    public static ROUTE_INFORMATIONEN_HILFE_SITEMAP = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_SITEMAP,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    public static ROUTE_INFORMATIONEN_HILFE_FAQ = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_FAQ,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    public static ROUTE_INFORMATIONEN_HILFE_GLOSSAR = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_GLOSSAR,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    public static ROUTE_INFORMATIONEN_HILFE_FOERDERUNG = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_FOERDERUNG,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    public static ROUTE_INFORMATIONEN_HILFE_MEDIEN = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_MEDIEN,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    public static ROUTE_INFORMATIONEN_HILFE_EMISSIONSFAKTOREN_HEIZWERTE = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_EMISSIONSFAKTOREN_HEIZWERTE,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    public static ROUTE_INFORMATIONEN_HILFE_VERSIONSHISTORIE = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_VERSIONSHISTORIE,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    public static ROUTE_INFORMATIONEN_HILFE_VERIFIZIERUNG = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_VERIFIZIERUNG,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    public static ROUTE_INFORMATIONEN_HILFE_KONTAKTE = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_KONTAKTE,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    public static ROUTE_INFORMATIONEN_HILFE_PARTNER = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_PARTNER,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    public static ROUTE_INFORMATIONEN_HILFE_NUTZUNGSBEDINGUNGEN = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_NUTZUNGSBEDINGUNGEN,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    public static ROUTE_INFORMATIONEN_HILFE_IMPRESSUM = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE]: RoutingIDs.TAB_INFORMATIONEN_HILFE_IMPRESSUM,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE
    };
    // Level 2
    public static ROUTE_BETRIEBLICHE_DATEN_MOTIVATION = {
        ...RoutingIDs.ROUTE_DATENEINGABE_BETRIEBLICHE_DATEN,
        [RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN]: RoutingIDs.TAB_BETRIEBLICHE_DATEN_MOTIVATION,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN
    };
    public static ROUTE_BETRIEBLICHE_DATEN_KONFIGURATION = {
        ...RoutingIDs.ROUTE_DATENEINGABE_BETRIEBLICHE_DATEN,
        [RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN]: RoutingIDs.TAB_BETRIEBLICHE_DATEN_KONFIGURATION,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN
    };
    public static ROUTE_BETRIEBLICHE_DATEN_UNTERNEHMENSDATEN = {
        ...RoutingIDs.ROUTE_DATENEINGABE_BETRIEBLICHE_DATEN,
        [RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN]: RoutingIDs.TAB_BETRIEBLICHE_DATEN_UNTERNEHMENSDATEN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN
    };
    public static ROUTE_BETRIEBLICHE_DATEN_STANDORTE_GEBAEUDE = {
        ...RoutingIDs.ROUTE_DATENEINGABE_BETRIEBLICHE_DATEN,
        [RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN]: RoutingIDs.TAB_BETRIEBLICHE_DATEN_STANDORTE_GEBAEUDE,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN
    };
    public static ROUTE_BETRIEBLICHE_DATEN_ZUSTAENDIGKEITEN = {
        ...RoutingIDs.ROUTE_DATENEINGABE_BETRIEBLICHE_DATEN,
        [RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN]: RoutingIDs.TAB_BETRIEBLICHE_DATEN_ZUSTAENDIGKEITEN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN
    };
    public static ROUTE_BETRIEBLICHE_DATEN_BWL_DATEN = {
        ...RoutingIDs.ROUTE_DATENEINGABE_BETRIEBLICHE_DATEN,
        [RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN]: RoutingIDs.TAB_BETRIEBLICHE_DATEN_BWL_DATEN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN
    };
    public static ROUTE_BETRIEBLICHE_DATEN_KENNZAHLEN = {
        ...RoutingIDs.ROUTE_DATENEINGABE_BETRIEBLICHE_DATEN,
        [RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN]: RoutingIDs.TAB_BETRIEBLICHE_DATEN_KENNZAHLEN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN
    };
    public static ROUTE_BETRIEBLICHE_DATEN_SONSTIGE_DATEN = {
        ...RoutingIDs.ROUTE_DATENEINGABE_BETRIEBLICHE_DATEN,
        [RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN]: RoutingIDs.TAB_BETRIEBLICHE_DATEN_SONSTIGE_DATEN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN
    };
    public static ROUTE_BETRIEBLICHE_DATEN_VERANSTALTUNGEN = {
        ...RoutingIDs.ROUTE_DATENEINGABE_BETRIEBLICHE_DATEN,
        [RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN]: RoutingIDs.TAB_BETRIEBLICHE_DATEN_VERANSTALTUNGEN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN
    };
    public static ROUTE_ENERGIEDATEN_STROM = {
        ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
        [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_STROM,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN
    };
    public static ROUTE_ENERGIEDATEN_WAERME = {
        ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
        [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_WAERME,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN
    };
    public static ROUTE_ENERGIEDATEN_KRAFTSTOFFE = {
        ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
        [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_KRAFTSTOFFE,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN
    };
    public static ROUTE_ENERGIEDATEN_WASSER = {
        ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
        [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_WASSER,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN
    };
    public static ROUTE_ENERGIEDATEN_EIGENSTROM = {
        ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
        [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_EIGENSTROM,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN
    };
    public static ROUTE_ENERGIEDATEN_EIGENWAERME = {
        ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
        [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_EIGENWAERME,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN
    };
    public static ROUTE_ENERGIEDATEN_KENNZIFFERN = {
        ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
        [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_KENNZIFFERN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN
    };
    public static ROUTE_ENERGIEDATEN_BWL_DATEN = {
        ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
        [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_BWL_DATEN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN
    };
    public static ROUTE_ENERGIEDATEN_KLIMAGASE = {
        ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
        [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_KLIMAGASE,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN
    };
    public static ROUTE_ENERGIEDATEN_SICHERHEITSZUSCHLAG = {
        ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
        [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_SICHERHEITSZUSCHLAG,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN
    };
    public static ROUTE_ENERGIEDATEN_SCOPE3_TRANSPORT_VORGELAGERT = {
        ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
        [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_SCOPE3_TRANSPORT_VORGELAGERT,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN
    };
    public static ROUTE_ENERGIEDATEN_SCOPE3_GESCHAEFTSREISEN = {
        ...RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
        [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_SCOPE3_GESCHAEFTSREISEN,
        terminateOn: RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN
    };
    public static ROUTE_DATENAUSWERTUNG_STROM = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_STROM,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_DATENAUSWERTUNG_WAERME = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_WAERME,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_DATENAUSWERTUNG_KRAFTSTOFFE = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_KRAFTSTOFFE,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_DATENAUSWERTUNG_WASSER = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_WASSER,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_DATENAUSWERTUNG_ENERGIEKENNZAHLEN = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_ENERGIEKENNZAHLEN,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_DATENAUSWERTUNG_ENERGIESTEUER = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_ENERGIESTEUER,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_DATENAUSWERTUNG_MASCHINEN_ANLAGEN_HEIZUNG = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_MASCHINEN_ANLAGEN_HEIZUNG,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_DATENAUSWERTUNG_FAHRZEUGE = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_FAHRZEUGE,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_DATENAUSWERTUNG_BETRIEBSDATEN = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_BETRIEBSDATEN,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_DATENAUSWERTUNG_ERNEUERBARE_ENERGIEN = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_ERNEUERBARE_ENERGIEN,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_DATENAUSWERTUNG_CO2_FUSS = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_CO2,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_DATENAUSWERTUNG_VSME = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_VSME,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_DATENAUSWERTUNG_KENNZAHLENBERECHNUNG = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE,
        [RoutingIDs.TABS_DATENAUSWERTUNG]: RoutingIDs.TAB_DATENAUSWERTUNG_KENNZAHLENBERECHNUNG,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG
    };
    public static ROUTE_ZERTIFIZIERUNG_OPTIONEN = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS_ZERTIFIZIERUNG,
        [RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG]: RoutingIDs.TAB_ZERTIFIZIERUNG_OPTIONEN,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG
    };
    public static ROUTE_ZERTIFIZIERUNG_INFO = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS_ZERTIFIZIERUNG,
        [RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG]: RoutingIDs.TAB_ZERTIFIZIERUNG_INFO,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG
    };
    public static ROUTE_ZERTIFIZIERUNG_TABELLEN = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS_ZERTIFIZIERUNG,
        [RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG]: RoutingIDs.TAB_ZERTIFIZIERUNG_TABELLEN,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG
    };
    public static ROUTE_ZERTIFIZIERUNG_TESTIERUNG = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS_ZERTIFIZIERUNG,
        [RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG]: RoutingIDs.TAB_ZERTIFIZIERUNG_TESTIERUNG,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG
    };
    public static ROUTE_PV_STANDARD = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS_PV,
        [RoutingIDs.TABS_ZUSATZTOOLS_PV]: RoutingIDs.TAB_PV_STANDARD,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_PV
    };
    public static ROUTE_PV_EXPERTE = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS_PV,
        [RoutingIDs.TABS_ZUSATZTOOLS_PV]: RoutingIDs.TAB_PV_EXPERTE,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_PV
    };
    public static ROUTE_EFFIZIENZNETZWERK_DOKUMENTENABLAGE = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS_EFFIZIENZNETZWERK,
        [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK]: RoutingIDs.TAB_EFFIZIENZNETZWERK_DOKUMENTENABLAGE,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK
    };
    public static ROUTE_EFFIZIENZNETZWERK_MONITORING_EINZELMASSNAHMEN = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS_EFFIZIENZNETZWERK,
        [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK]: RoutingIDs.TAB_EFFIZIENZNETZWERK_MONITORING_EINZELMASSNAHMEN,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK
    };
    public static ROUTE_PARTNER_FINANZIERUNG = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE_PARTNER,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE_PARTNER]: RoutingIDs.TAB_PARTNER_FINANZIERUNG,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE_PARTNER
    };
    public static ROUTE_PARTNER_ENTWICKLUNG = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE_PARTNER,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE_PARTNER]: RoutingIDs.TAB_PARTNER_ENTWICKLUNG,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE_PARTNER
    };
    public static ROUTE_PARTNER_WEITERFUEHREND = {
        ...RoutingIDs.ROUTE_INFORMATIONEN_HILFE_PARTNER,
        [RoutingIDs.TABS_INFORMATIONEN_HILFE_PARTNER]: RoutingIDs.TAB_PARTNER_WEITERFUEHREND,
        terminateOn: RoutingIDs.TABS_INFORMATIONEN_HILFE_PARTNER
    };
    // Level 3
    public static ROUTE_ENERGIEKENNZAHLEN_KOSTENBEZOGEN = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIEKENNZAHLEN,
        [RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN]: RoutingIDs.TAB_ENERGIEKENNZAHLEN_KOSTENBEZOGEN,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN
    };
    public static ROUTE_ENERGIEKENNZAHLEN_VERBRAUCHSBEZOGEN = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIEKENNZAHLEN,
        [RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN]: RoutingIDs.TAB_ENERGIEKENNZAHLEN_VERBRAUCHSBEZOGEN,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN
    };
    public static ROUTE_ENERGIEKENNZAHLEN_KOSTENBEZOGEN_SPEZ = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIEKENNZAHLEN,
        [RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN]: RoutingIDs.TAB_ENERGIEKENNZAHLEN_KOSTENBEZOGEN_SPEZ,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN
    };
    public static ROUTE_ENERGIEKENNZAHLEN_VERBRAUCHSBEZOGEN_SPEZ = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIEKENNZAHLEN,
        [RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN]: RoutingIDs.TAB_ENERGIEKENNZAHLEN_VERBRAUCHSBEZOGEN_SPEZ,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN
    };
    public static ROUTE_ENERGIEKENNZAHLEN_CO2_EMISSIONEN = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIEKENNZAHLEN,
        [RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN]: RoutingIDs.TAB_ENERGIEKENNZAHLEN_CO2_EMISSIONEN,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN
    };
    public static ROUTE_ENERGIEKENNZAHLEN_BROWSER = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIEKENNZAHLEN,
        [RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN]: RoutingIDs.TAB_ENERGIEKENNZAHLEN_BROWSER,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_ENERGIEKENNZAHLEN
    };
    public static ROUTE_CO2_FUSS_GESAMT = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS,
        [RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS]: RoutingIDs.TAB_CO2_FUSS_GESAMT,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS
    };
    public static ROUTE_CO2_FUSS_DETAILS = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS,
        [RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS]: RoutingIDs.TAB_CO2_FUSS_DETAILS,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS
    };
    public static ROUTE_CO2_FUSS_ANTEIL_STANDORTE = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS,
        [RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS]: RoutingIDs.TAB_CO2_FUSS_ANTEIL_STANDORTE,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS
    };
    public static ROUTE_CO2_FUSS_THG_BERICHT = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS,
        [RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS]: RoutingIDs.TAB_CO2_FUSS_THG_BERICHT,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS
    };
    public static ROUTE_VSME_AUSWERTUNG = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_VSME,
        [RoutingIDs.TABS_DATENAUSWERTUNG_VSME]: RoutingIDs.TAB_VSME_AUSWERTUNG,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_VSME
    };
    public static ROUTE_VSME_REPORT = {
        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_VSME,
        [RoutingIDs.TABS_DATENAUSWERTUNG_VSME]: RoutingIDs.TAB_VSME_REPORT,
        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_VSME
    };
    public static ROUTE_ZERTIFIZIERUNG_TABELLE1 = {
        ...RoutingIDs.ROUTE_ZERTIFIZIERUNG_TABELLEN,
        [RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG_TABELLEN]: RoutingIDs.TAB_ZERTIFIZIERUNG_TABELLE1,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG_TABELLEN
    };
    public static ROUTE_ZERTIFIZIERUNG_TABELLE2 = {
        ...RoutingIDs.ROUTE_ZERTIFIZIERUNG_TABELLEN,
        [RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG_TABELLEN]: RoutingIDs.TAB_ZERTIFIZIERUNG_TABELLE2,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG_TABELLEN
    };
    public static ROUTE_ZERTIFIZIERUNG_TABELLE3 = {
        ...RoutingIDs.ROUTE_ZERTIFIZIERUNG_TABELLEN,
        [RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG_TABELLEN]: RoutingIDs.TAB_ZERTIFIZIERUNG_TABELLE3,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_ZERTIFIZIERUNG_TABELLEN
    };
    // AB HIER NUN DIE MAP MIT DEN ROUTEN FÜR JEDE ENTITY
    public static ENTITY_ROUTES = {
        [IDs.ENT_MASCHINEN]: {
            ...RoutingIDs.ROUTE_STANDORT,
            [RoutingIDs.TABS_STANDORTE_DETAIL]: RoutingIDs.TAB_STANDORT_MASCHINEN_ANLAGEN
        },
        [IDs.ENT_FAHRZEUGE]: {
            ...RoutingIDs.ROUTE_STANDORT,
            [RoutingIDs.TABS_STANDORTE_DETAIL]: RoutingIDs.TAB_STANDORT_FAHRZEUGE
        },
        [IDs.ENT_STANDORT_ENERGIETRAEGER]: {
            ...RoutingIDs.ROUTE_STANDORT,
            [RoutingIDs.TABS_STANDORTE_DETAIL]: RoutingIDs.TAB_STANDORT_ENERGIETRAEGER
        },
        [IDs.ENT_GEBAEUDE]: {
            ...RoutingIDs.ROUTE_STANDORT,
            [RoutingIDs.TABS_STANDORTE_DETAIL]: RoutingIDs.TAB_STANDORT_GEBAEUDE
        },
        [IDs.ENT_ANLAGEN_EIGENSTROM_BIOMASSE]: {
            ...RoutingIDs.ROUTE_ERNEUERBARE_ENERGIEN,
            tabStandorteEigenstromTabs: RoutingIDs.TAB_ERNEUERBARE_ENERGIEN_BIOMASSE
        },
        [IDs.ENT_ANLAGEN_EIGENSTROM_WAERMEPUMPEN]: {
            ...RoutingIDs.ROUTE_ERNEUERBARE_ENERGIEN,
            tabStandorteEigenstromTabs: RoutingIDs.TAB_ERNEUERBARE_ENERGIEN_WAERMEPUMPEN
        },
        [IDs.ENT_ANLAGEN_EIGENSTROM_WINDKRAFT]: {
            ...RoutingIDs.ROUTE_ERNEUERBARE_ENERGIEN,
            tabStandorteEigenstromTabs: RoutingIDs.TAB_ERNEUERBARE_ENERGIEN_WINDKRAFT
        },
        [IDs.ENT_ANLAGEN_EIGENSTROM_SOLARTHERMIE]: {
            ...RoutingIDs.ROUTE_ERNEUERBARE_ENERGIEN,
            tabStandorteEigenstromTabs: RoutingIDs.TAB_ERNEUERBARE_ENERGIEN_SOLARTHERMIE
        },
        [IDs.ENT_ANLAGEN_EIGENSTROM_PHOTOVOLTAIK]: {
            ...RoutingIDs.ROUTE_ERNEUERBARE_ENERGIEN,
            tabStandorteEigenstromTabs: RoutingIDs.TAB_ERNEUERBARE_ENERGIEN_PHOTOVOLTAIK
        },
        [IDs.ENT_ANLAGEN_EIGENSTROM_KWK]: {
            ...RoutingIDs.ROUTE_ERNEUERBARE_ENERGIEN,
            tabStandorteEigenstromTabs: RoutingIDs.TAB_ERNEUERBARE_ENERGIEN_KWK
        },
        [IDs.ENT_ENERGIEDATEN_WAERME]: {
            ...RoutingIDs.ROUTE_ENERGIEDATEN,
            [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_WAERME
        },
        [IDs.ENT_ENERGIEDATEN_STROM]: {
            ...RoutingIDs.ROUTE_ENERGIEDATEN,
            [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_STROM
        },
        [IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE]: {
            ...RoutingIDs.ROUTE_ENERGIEDATEN,
            [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_KRAFTSTOFFE
        },
        [IDs.ENT_ENERGIEDATEN_WASSER]: {
            ...RoutingIDs.ROUTE_ENERGIEDATEN,
            [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_WASSER
        },
        [IDs.ENT_ENERGIEDATEN_EIGENSTROM]: {
            ...RoutingIDs.ROUTE_ENERGIEDATEN,
            [RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN]: RoutingIDs.TAB_ENERGIEDATEN_EIGENSTROM
        }
    };
}
